<template>
  <svg
    width="50"
    height="40"
    viewBox="0 0 50 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.0327 28.5101H41.0116C42.5896 28.5101 43.8688 27.231 43.8688 25.653C43.8688 24.075 42.5896 22.7958 41.0116 22.7958H47.0327C48.6107 22.7958 49.8898 21.5167 49.8898 19.9387C49.8898 18.3607 48.6107 17.0815 47.0327 17.0815H29.7167C31.2947 17.0815 32.5738 15.8023 32.5738 14.2243C32.5738 12.6464 31.2947 11.3672 29.7167 11.3672H10.8601C9.28209 11.3672 8.00293 12.6464 8.00293 14.2243C8.00293 15.8023 9.28209 17.0815 10.8601 17.0815H16.8812C15.3032 17.0815 14.024 18.3607 14.024 19.9387C14.024 21.5167 15.3032 22.7958 16.8812 22.7958H10.8601C9.28209 22.7958 8.00293 24.075 8.00293 25.653C8.00293 27.2309 9.28209 28.5101 10.8601 28.5101H16.8812C15.3032 28.5101 14.024 29.7893 14.024 31.3673C14.024 32.9453 15.3032 34.2244 16.8812 34.2244H13.161C11.583 34.2244 10.3039 35.5036 10.3039 37.0816C10.3039 38.6596 11.583 39.9388 13.161 39.9388H43.3125C44.8905 39.9388 46.1697 38.6596 46.1697 37.0816C46.1697 35.5036 44.8905 34.2244 43.3125 34.2244H47.0327C48.6107 34.2244 49.8898 32.9453 49.8898 31.3673C49.8898 29.7893 48.6106 28.5101 47.0327 28.5101Z"
      fill="url(#paint0_linear_7823_125336)"
      fill-opacity="0.2"
    />
    <path
      d="M46.9724 5.71436H38.7234C37.1454 5.71436 35.8662 6.99352 35.8662 8.57151C35.8662 10.1495 37.1454 11.4287 38.7234 11.4287H47.0951C48.7657 11.4287 50.1014 9.99505 49.939 8.2909C49.7973 6.80537 48.4647 5.71436 46.9724 5.71436Z"
      fill="url(#paint1_linear_7823_125336)"
      fill-opacity="0.2"
    />
    <path
      d="M19.1091 0H10.8601C9.28209 0 8.00293 1.27916 8.00293 2.85716C8.00293 4.43515 9.28209 5.71431 10.8601 5.71431H19.2318C20.9024 5.71431 22.2381 4.28069 22.0757 2.57654C21.9341 1.09101 20.6014 0 19.1091 0Z"
      fill="url(#paint2_linear_7823_125336)"
      fill-opacity="0.2"
    />
    <path
      d="M4.83457 34.2856H2.85716C1.27916 34.2856 0 35.5648 0 37.1428C0 38.7208 1.27916 40 2.85716 40H4.9573C6.62785 40 7.96353 38.5663 7.80113 36.8622C7.65941 35.3767 6.32686 34.2856 4.83457 34.2856Z"
      fill="url(#paint3_linear_7823_125336)"
      fill-opacity="0.2"
    />
    <path
      d="M41.5261 13.0829C41.5261 16.8272 38.4847 19.8686 34.7333 19.8686C30.9818 19.8686 27.9404 16.8272 27.9404 13.0829C27.9404 9.33143 30.9818 6.29004 34.7333 6.29004C38.4847 6.29004 41.5261 9.33143 41.5261 13.0829Z"
      fill="#D8F2F3"
    />
    <path
      d="M15.5524 16.1978C14.4041 16.1978 13.4697 17.132 13.4697 18.2803C13.4697 19.4315 14.4041 20.3681 15.5524 20.3681C16.7034 20.3681 17.64 19.4315 17.64 18.2803C17.64 17.1319 16.7035 16.1978 15.5524 16.1978ZM15.5524 19.369C14.9549 19.369 14.4688 18.8808 14.4688 18.2803C14.4688 17.6827 14.9549 17.1968 15.5524 17.1968C16.1526 17.1968 16.641 17.6827 16.641 18.2803C16.641 18.8807 16.1527 19.369 15.5524 19.369Z"
      fill="#237276"
    />
    <path
      d="M33.1034 4.01514C29.0824 4.01514 25.8111 7.28641 25.8111 11.3074C25.8111 11.8575 25.8777 12.3915 25.9939 12.907H12.0941C10.0723 12.907 8.42774 14.5519 8.42774 16.5734C8.42764 18.0927 8.42813 10.9089 8.42676 32.318C8.42676 34.3461 10.0782 35.9849 12.0941 35.9849H27.839C29.8737 35.9849 31.5063 34.3266 31.5063 32.318C31.5063 31.0856 31.5066 37.1017 31.5054 18.4111C32.0205 18.5268 32.554 18.5929 33.1034 18.5929C37.1245 18.5929 40.396 15.3246 40.396 11.3074C40.3959 7.28641 37.1245 4.01514 33.1034 4.01514ZM30.5063 29.5516V32.3184C30.5063 33.8247 29.234 34.9853 27.8397 34.9853H12.093C10.6228 34.9853 9.42668 33.7887 9.42668 32.3184V29.5516H30.5063ZM12.2267 28.5521L15.3278 24.0091L17.2059 26.753C17.299 26.8891 17.4532 26.9705 17.618 26.9705H17.6182C17.7831 26.9705 17.9375 26.889 18.0304 26.753L22.2498 20.5763L27.705 28.5476L12.2267 28.5521ZM30.5063 28.5525H28.9189L22.6618 19.4095C22.5687 19.2733 22.4145 19.1919 22.2497 19.1919H22.2495C22.0846 19.1919 21.9302 19.2734 21.8373 19.4095L17.6179 25.5862L15.7396 22.8418C15.6465 22.7056 15.4923 22.6242 15.3275 22.6242H15.3272C15.1621 22.6242 15.0079 22.7057 14.9147 22.8422L11.0172 28.5525H9.42668V16.5734C9.42668 15.1026 10.6233 13.906 12.094 13.906H26.2989C27.0397 15.8349 28.575 17.368 30.5062 18.1069L30.5063 28.5525ZM33.1034 17.5939C29.6333 17.5939 26.8102 14.7738 26.8102 11.3074C26.8102 7.83715 29.6333 5.01418 33.1034 5.01418C36.5737 5.01418 39.397 7.83715 39.397 11.3074C39.3969 14.7738 36.5737 17.5939 33.1034 17.5939Z"
      fill="#237276"
    />
    <path
      d="M35.7282 10.8922L32.1167 8.40394C31.964 8.29855 31.7653 8.28738 31.6013 8.37269C31.4369 8.45908 31.334 8.62931 31.3337 8.81462L31.3281 13.7913C31.3279 13.9767 31.4306 14.1474 31.5949 14.2337C31.759 14.3201 31.957 14.3087 32.1108 14.2035L35.7279 11.7152C35.8633 11.622 35.9443 11.4679 35.9443 11.3034C35.9444 11.1391 35.8636 10.9854 35.7282 10.8922ZM32.3281 12.841L32.3318 9.76537L34.5637 11.3029L32.3281 12.841Z"
      fill="#237276"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7823_125336"
        x1="28.9464"
        y1="11.3672"
        x2="28.9464"
        y2="39.9388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8F2F3" />
        <stop offset="0.5" stop-color="#237276" stop-opacity="0.7" />
        <stop offset="1" stop-color="#237276" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7823_125336"
        x1="42.9093"
        y1="5.71436"
        x2="42.9093"
        y2="11.4287"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8F2F3" />
        <stop offset="0.5" stop-color="#237276" stop-opacity="0.7" />
        <stop offset="1" stop-color="#237276" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7823_125336"
        x1="15.046"
        y1="0"
        x2="15.046"
        y2="5.71431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8F2F3" />
        <stop offset="0.5" stop-color="#237276" stop-opacity="0.7" />
        <stop offset="1" stop-color="#237276" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7823_125336"
        x1="3.90726"
        y1="34.2856"
        x2="3.90726"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8F2F3" />
        <stop offset="0.5" stop-color="#237276" stop-opacity="0.7" />
        <stop offset="1" stop-color="#237276" />
      </linearGradient>
    </defs>
  </svg>
</template>
